import { render, staticRenderFns } from "./OrderFee.vue?vue&type=template&id=54ec6f82&"
import script from "./OrderFee.vue?vue&type=script&lang=js&"
export * from "./OrderFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports